import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRoute$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRoute extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'dffa82cd241614dfba756dad6c29eb5cbf8f7f8d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7158c2b9bdf70feacc38ce4ec83910117fea1750', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '67af10c5e4e79078642f6242c65eb81cb7ee937d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.875 6.875a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25M7 5a3.125 3.125 0 1 0 0 6.25h7c1.079 0 1.75.546 1.75 1.625S15.079 14.5 14 14.5H8V16h6a3.125 3.125 0 1 0 0-6.25H7c-1.079 0-1.75-.546-1.75-1.625S5.921 6.5 7 6.5h6V5zM4 15.25a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-route", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-route"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-route":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRoute$1);
            }
            break;
    } });
}

const CosmosIconRoute = CosmosIconRoute$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRoute, defineCustomElement };
